import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=37f3faae&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=37f3faae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f3faae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37f3faae')) {
      api.createRecord('37f3faae', component.options)
    } else {
      api.reload('37f3faae', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=37f3faae&scoped=true&", function () {
      api.rerender('37f3faae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2I3yPMKth5714/JS/comp/PopupDialog.vue"
export default component.exports